<template>
  <div class="bj">
    <header>
      <p>稿件信息</p>
    </header>

    <div class="content">
      <!-- 原创设置 -->
      <div class="con">
<!--        <div class="conflex">-->
<!--          <p class="xing">原创设置</p>-->
<!--          <div class="conradio">-->
<!--            <a-radio-group-->
<!--              name="radioGroup"-->
<!--              @change="coverRadioIsOriginal"-->
<!--              :default-value="dataInfo.isOriginal"-->
<!--            >-->
<!--              <a-radio :value="0"> 原创 </a-radio>-->
<!--              <a-radio :value="1"> 非原创 </a-radio>-->
<!--            </a-radio-group>-->
<!--          </div>-->
<!--        </div>-->
        <div v-if="dataInfo.isOriginal == 1" class="inputgroup">
          <a-input
            v-model="dataInfo.originalTitle"
            style="width: 35%"
            placeholder="稿件来源"
          />
          <a-input
            v-model="dataInfo.originalUrl"
            style="width: 60%"
            placeholder="http://"
          />
        </div>
      </div>


      <!-- 摘要 -->
      <div class="con">
        <div class="conflex">
          <p>摘要</p>
<!--          <div class="onetouch">一键生成</div>-->
        </div>
        <a-textarea v-model="dataInfo.summary" :auto-size="{ minRows: 4, maxRows: 6 }" />
      </div>

      <!-- 副标题 -->
      <div class="con">
        <div class="conflex">
          <p class="xin">副标题</p>
<!--          <div class="onetouch">一键生成</div>-->
        </div>
        <a-input v-model="dataInfo.subtitle" />
      </div>

      <!-- 编辑 -->
      <div class="con">
        <div class="consame xin">编辑</div>
        <a-input v-model="dataInfo.editor" placeholder="请输入"/>
      </div>

      <!-- 责编 -->
      <div class="con">
        <div class="consame">责编</div>
        <a-input v-model="dataInfo.responsibleEditor" placeholder="请输入"/>
<!--        <a-select show-search @search="handleChangeRes" v-model="dataInfo.responsibleEditor" placeholder="请选择"-->
<!--          style="width: 100%">-->
<!--          <a-select-option v-for="(e, i) in resUserList" :key="i" :value="e.likeName">-->
<!--            {{ e.likeName }}-->
<!--          </a-select-option>-->
<!--        </a-select>-->
      </div>

      <!-- 记者 -->
      <div class="con">
        <div class="consame">记者</div>
        <a-input v-model="dataInfo.reporter" placeholder="请输入"/>
        <!--        <a-select show-search @search="handleChangeRep" v-model="dataInfo.reporter" placeholder="请选择"-->
<!--                  style="width: 100%">-->
<!--          <a-select-option v-for="(e, i) in reporterUserList" :key="i" :value="e.likeName">-->
<!--            {{ e.likeName }}-->
<!--          </a-select-option>-->
<!--        </a-select>-->
      </div>
      <div class="con">
        <div class="consame">来源</div>
        <a-input v-model="dataInfo.originalTitle" placeholder="请输入"/>
        <!--        <a-select show-search @search="handleChangeRep" v-model="dataInfo.reporter" placeholder="请选择"-->
<!--                  style="width: 100%">-->
<!--          <a-select-option v-for="(e, i) in reporterUserList" :key="i" :value="e.likeName">-->
<!--            {{ e.likeName }}-->
<!--          </a-select-option>-->
<!--        </a-select>-->
      </div>
<div class="con">
        <div class="consame">点击量</div>
        <a-input v-model="dataInfo.clickCount" placeholder="请输入"/>
       
      </div>

      <!-- 分享封面 -->
<!--      <div class="con">-->
<!--        <div class="consame">分享封面</div>-->
<!--        <div class="inputgroup">-->
<!--          <a-upload name="avatar" list-type="picture-card" class="avatar-uploader" :show-upload-list="false"-->
<!--            :customRequest="uploaderShareCover">-->
<!--            <img v-if="dataInfo.shareCover" :src="dataInfo.shareCover" alt="avatar" />-->
<!--            <div v-else>-->
<!--              <a-icon :type="loading ? 'loading' : 'plus'" />-->
<!--              <div class="ant-upload-text"></div>-->
<!--            </div>-->
<!--          </a-upload>-->

<!--          <a-textarea v-model="dataInfo.shareDesc" style="height: 6.5rem; margintop: -0.5rem" />-->
<!--        </div>-->
<!--        <div class="tip">Ps:分享封面和描述将展示在分享链接中</div>-->
<!--      </div>-->
    </div>
    <!-- <div v-if="!isPut" @click="isPut = !isPut" class="put">
      <p>收起</p>
      <img src="@/assets/components/put.png" alt="" />
    </div>
    <div v-else @click="isPut = !isPut" class="open">
      <p>更多设置</p>
      <img src="@/assets/components/open.png" alt="" />
    </div> -->
  </div>

  <!-- <a-select default-value="lucy" style="width:100%;">
          <a-select-option value="jack">
            Jack
          </a-select-option>
          <a-select-option value="lucy">
            Lucy
          </a-select-option>
        </a-select> -->
</template>

<script>
  import {
    fileUpload
  } from "../../api/content";
  import {
    listInternalUser
  } from "../../api/system";
  import {
    mapGetters
  } from "vuex";
  export default {
    props: {
      dataInfo: {
        type: Object,
        default: function () {
          return {
            summary: "", // 摘要
            originalTitle: "", //稿件标题
            originalUrl: "", //稿件地址
            clickCount: 0, //点击量
            // keyword: "", // 关键词
            // label: "", // 标签
            editor: "", // 编辑
            reporter: "", // 记者
            responsibleEditor: "", //责编
            shareDesc: "", // 分享地址
            shareCover: "", // 分享图片地址
            originalTitle: '',
            subtitle:'',//副标题
          };
        },
      },
    },
    computed: {
      ...mapGetters(["userId"]),
    },
    watch: {
      dataInfo(e) {},
    },
    data() {
      return {
        loading: false,
        imageUrlOne: "",
        imageUrlTwo: "",
        imageUrlThree: "",

        isPut: true,
        reporterUserList: [], //记者用户列表
        resUserList: [], //责编用户列表
      };
    },
    methods: {
      handleChange(info) {
        if (info.file.status === "uploading") {
          this.loading = true;
          return;
        }
        if (info.file.status === "done") {
          // getBase64(info.file.originFileObj, imageUrl => {
          //   this.imageUrl = imageUrl;
          //   this.loading = false;
          // });
        }
      },
      beforeUpload(file) {
        const isJpgOrPng =
          file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
          this.$message.error("You can only upload JPG file!");
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error("Image must smaller than 2MB!");
        }
        return isJpgOrPng && isLt2M;
      },
      handleChangeRep(val) {
        this.getRepListInternalUser({
          keyword: val
        });
      },
      handleChangeRes(val) {
        this.getResListInternalUser({
          keyword: val
        });
      },
      async getRepListInternalUser(val = {}) {
        let {
          status,
          data,
          message,
          errors
        } = await listInternalUser({
          pageSize: 15,
          ...val,
        });
        if (status) {
          this.reporterUserList = data;
        }
      },
      async getResListInternalUser(val = {}) {
        let {
          status,
          data,
          message,
          errors
        } = await listInternalUser({
          pageSize: 15,
          ...val,
        });
        if (status) {
          this.resUserList = data;
        }
      },

      async uploaderCoverUrlOne(option) {
        var form = new FormData();
        form.append("file ", option.file);
        let data = await fileUpload(form);
        this.imageUrlOne = data.data.filedir;
        this.dataInfo.coverUrl = data.data.filedir;
      },
      async uploaderCoverUrlTwo(option) {
        var form = new FormData();
        form.append("file ", option.file);
        let data = await fileUpload(form);
        this.imageUrlTwo = data.data.filedir;
        this.dataInfo.coverUrl += "," + data.data.filedir;
      },
      async uploaderCoverUrlThree(option) {
        var form = new FormData();
        form.append("file ", option.file);
        let data = await fileUpload(form);
        this.imageUrlThree = 'http://xhrb.oss-cn-hangzhou.aliyuncs.com/' + data.data.fileurl;
        this.dataInfo.coverUrl += "," + data.data.filedir;
      },

      async uploaderShareCover(option) {
        console.log(this.dataInfo.shareCover);
        var form = new FormData();
        form.append("file ", option.file);
        let data = await fileUpload(form);
        this.dataInfo.shareCover = data.data.filedir;
        console.log(data.data.filedir);
      },

      coverRadioCoverType(e) {
        this.dataInfo.coverType = e.target.value;
        this.dataInfo.coverUrl = "";
        this.imageUrlOne = "";
        this.imageUrlTwo = "";
        this.imageUrlThree = "";
      },
      coverRadioIsOriginal(e) {
        this.dataInfo.isOriginal = e.target.value;
      },
    },
    mounted() {
      // this.getRepListInternalUser();
      // this.getResListInternalUser();
      // if (this.dataInfo.coverUrl) {
      //   let coverArry = this.dataInfo.coverUrl.split(",");
      //   if (this.dataInfo.coverType == 0) {
      //     this.imageUrlOne = coverArry[0];
      //   } else if (this.dataInfo.coverType == 1) {
      //     this.imageUrlOne = coverArry[0];
      //     this.imageUrlTwo = coverArry[1];
      //     this.imageUrlThree = coverArry[2];
      //   } else if (this.dataInfo.coverType == 2) {
      //     this.imageUrlOne = coverArry[0];
      //   }
      // }
    },
    created() {
      if (sessionStorage.getItem("articleContent")) {
        let arr = JSON.parse(sessionStorage.getItem("articleContent"))
        this.dataInfo.editor=arr.editor
        this.dataInfo.reporter=arr.reporter
        this.dataInfo.responsibleEditor=arr.responsibleEditor
        this.dataInfo.originalTitle=arr.originalTitle
        this.dataInfo.clickCount=arr.clickCount
      }
    },
  };
</script>

<style scoped lang="scss">
  .bj {
    width: 21vw;
    //width: 302px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(176, 176, 176, 0.2);
    // padding: 24px;
    padding-top: 0;
    padding-bottom: 60px;
    box-sizing: border-box;
    border-radius: 2px;
    position: relative;

    header {
      box-sizing: border-box;
      // border-bottom: 2px solid #F8FAFF;
      margin-bottom: 16px;
      background: white;
      padding-top: 24px;
      //padding-left: 24px;
      padding-right: 24px;
      box-sizing: border-box;
      position: sticky;
      top: 0;
      z-index: 99;

      p {
        //width: 58px;
        font-size: 14px;
        font-weight: 600;
        color: #FF373C;
        padding-left: 1rem;
        border-left: 3px solid #FF373C;
        height: 18px;
        line-height: 18px;

      }
    }

    .put {
      position: absolute;
      bottom: 8px;
      left: calc(50% - 25px);
      @include flex(flex-start);
      font-size: 14px;
      font-weight: 400;
      color: #106aff;
      cursor: pointer;

      p {
        margin-right: 6px;
      }
    }

    .open {
      position: absolute;
      bottom: 8px;
      left: calc(50% - 39px);
      @include flex(flex-start);
      font-size: 14px;
      font-weight: 400;
      color: #106aff;
      cursor: pointer;

      p {
        margin-right: 6px;
      }
    }

    .content {
      width: 100%;
      padding-left: 24px;
      padding-right: 24px;
      box-sizing: border-box;
      height: calc(100vh - 302px);
      overflow-x: auto;
      transition: height 0.2s;

      .con {
        margin-bottom: 16px;

        /deep/.ant-input{
          border: 1px solid #E5E5E5;
          &:hover{
            border: 1px solid red;
          }
          &:focus{
            border: 1px solid red;
            box-shadow:none;
            outline-style: none;
          }
        }
        .consame {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          margin-bottom: 8px;
 
          
        }
        .xin{
          &::before {
            content: "*";
            color: red;
            font-size: 18px;
            margin-right: 4px;
          }
        }

        .conflex {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          margin-bottom: 8px;
          @include flex();

          .onetouch {
            font-size: 12px;
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #FF5E5D;
          }
        }

        .conradio {
          @include flex();

          /deep/ .ant-radio-group {
            width: 100%;

            .ant-radio-wrapper {
              margin-right: 0;
              margin-left: 7px;
            }
          }

          /deep/ span.ant-radio+* {
            padding-right: 0;
          }
        }

        .xing {
          &::before {
            content: "*";
            color: red;
            font-size: 18px;
            margin-right: 4px;
          }
        }

        .inputgroup {
          @include flex();

          /deep/ .ant-upload {
            padding: 0;
          }

          /deep/ .ant-upload img {
            width: 80px;
            height: 70px;
            background-size: cover;
            border-radius: 0;
          }
        }

        .uploads {
          @include flex();
          margin-top: 16px;

          /deep/ .ant-upload.ant-upload-select-picture-card {
            width: 80px;
            height: 80px;
            border-radius: 0;
          }

          /deep/ .ant-upload {
            padding: 0;
          }

          /deep/ .ant-upload img {
            width: 80px;
            height: 70px;
            background-size: cover;
            border-radius: 0;
          }
        }

        .tip {
          font-size: 14px;
          font-weight: 400;
          color: #cccccc;
          line-height: 20px;
        }
      }
    }
  }
</style>